import {TextProps} from '@mintdata/mint-components/components/text/Text';
import {BaseLogic} from '@mintdata/mint-kit/api/events/BaseLogic';

export class TextLogic extends BaseLogic<TextProps>
{
    // protected onValueChanged(e:AChangeEvent<AString>, props:TextProps)
    // {
    // 	props.model.text = e.newValue;
    // }
}
